import axios from '@/helpers/axios';

const state = {
  data: [],
  url:
    'https://services1.arcgis.com/0MSEUqKaxRlEPj5g/arcgis/rest/services/ncov_cases/FeatureServer/1/query?f=json&where=(Confirmed%3E%200)%20OR%20(Deaths%3E0)%20OR%20(Recovered%3E0)&returnGeometry=false&spatialRef=esriSpatialRelIntersects&outFields=*&orderByFields=Country_Region%20asc,Province_State%20asc&resultOffset=0&resultRecordCount=250&cacheHint=true',
  confirmed: 0,
  deaths: 0,
  recovered: 0,
  loading: false,
  locationPoints: [],
  updatedAt: ''
};

const getters = {
  dataGetData(state) {
    return state.data;
  },
  dataGetLoading(state) {
    return state.loading;
  },
  dataGetStats(state) {
    return {
      confirmed: state.confirmed,
      recovered: state.recovered,
      deaths: state.deaths
    };
  },
  dataGetLocation(state) {
    return state.locationPoints;
  }
};

const mutations = {
  dataSetData(state, data) {
    data.forEach((tab, index) => {
      let parsedLastUpdate = new Date(tab.attributes.Last_Update);
      let parsed = {
        countryRegion: tab.attributes.Country_Region == null ? '' : tab.attributes.Country_Region,
        provinceState: tab.attributes.Province_State == null ? '' : tab.attributes.Province_State,
        lastUpdate: `${parsedLastUpdate.toLocaleDateString()} - ${parsedLastUpdate.toLocaleTimeString()}`,
        confirmed: tab.attributes.Confirmed,
        deaths: tab.attributes.Deaths,
        recovered: tab.attributes.Recovered,
        lat: tab.attributes.Lat,
        lng: tab.attributes.Long_,
        id: index + 1
      };
      state.confirmed = state.confirmed + tab.attributes.Confirmed;
      state.deaths = state.deaths + tab.attributes.Deaths;
      state.recovered = state.recovered + tab.attributes.Recovered;
      let location = [
        tab.attributes.Lat,
        tab.attributes.Long_,
        {
          countryRegion: tab.attributes.Country_Region == null ? '' : tab.attributes.Country_Region,
          provinceState: tab.attributes.Province_State == null ? '' : tab.attributes.Province_State,
          confirmed: tab.attributes.Confirmed,
          deaths: tab.attributes.Deaths,
          recovered: tab.attributes.Recovered
        }
      ];
      state.locationPoints.push(location);
      state.data.push(parsed);
    });
    state.loading = false;
  },
  dataClearData(state) {
    state.data = [];
    state.confirmed = 0;
    state.deaths = 0;
    state.recovered = 0;
  },
  dataDistributionServerData(state, data) {
    state.locationPoints = data.location;
    state.data = data.parsed;
    state.confirmed = data.stats.confirmed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    state.deaths = data.stats.deaths.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    state.recovered = data.stats.recovered.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
};

const actions = {
  dataCallData(context) {
    context.commit('dataClearData');
    context.state.loading = true;
    axios
      .get(context.state.url)
      .then(r => {
        context.commit('dataSetData', r.data.features);
      })
      .catch(err => {
        context.state.loading = false;
        console.log(err);
      });
  },
  serverAfterConnect(context) {
    // context.dispatch('dataCallData');
    context.dispatch('dataServerCallData');
    window.setInterval(() => {
      context.dispatch('dataServerCallData');
    }, 1000 * 60 * 10);
  },
  dataServerCallData(context) {
    context.commit('dataClearData');
    context
      .dispatch('serverRequest', {
        action: 'viruswatch/data-retrieve'
      })
      .then(response => {
        context.commit('dataDistributionServerData', response.data.viruswatch[0]);
      })
      .catch(err => {
        console.log(err);
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
